<template>
  <div :class="['ms-form', {purpose: this.data?.body?.purpose}]">
    <q-form @submit="this.onSubmit">
      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-ruler-vertical" aria-hidden="true" />Основное</h3>
        <div class="ms-form-grid">
          <CustomInput
            label="Код"
            :value="this.formData.code || ''"
            @change_input="(value) => onChange('code', value)"
          />
          <CustomInput
            label="Ширина откоса"
            type="number"
            :value="this.formData.slope_width === 0 ? '0' : this.formData.slope_width || ''"
            @change_input="(value) => onChange('slope_width', value)"
          />
          <CustomInput
            :required="true"
            label="Высота стен (мм)"
            type="number"
            :value="this.formData.wall_height === 0 ? '0' : this.formData.wall_height || ''"
            @change_input="(value) => onChange('wall_height', value)"
          />
          <CustomInput
            :required="true"
            label="Высота дверей (мм)"
            type="number"
            :value="this.formData.door_height === 0 ? '0' : this.formData.door_height || ''"
            @change_input="(value) => onChange('door_height', value)"
          />
          <CustomInput
            :required="true"
            label="Высота окон (мм)"
            type="number"
            :value="this.formData.window_height === 0 ? '0' : this.formData.window_height || ''"
            @change_input="(value) => onChange('window_height', value)"
          />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-ruler-combined" aria-hidden="true" />Масштаб и координаты</h3>
        <div class="ms-form-grid">
          <CustomInput
            label="1 unit автокад равен X пикселям"
            type="number"
            :value="this.formData.scale === 0 ? '0' : this.formData.scale || ''"
            @change_input="(value) => onChange('scale', value)"
          />
          <CustomInput
            label="1 длина автокад равна X мм"
            type="number"
            :value="this.formData.autocad_scale === 0 ? '0' : this.formData.autocad_scale || ''"
            @change_input="(value) => onChange('autocad_scale', value)"
          />
          <CustomInput
            label="Min X"
            type="number"
            :allowNegative="true"
            :value="this.formData.min_x === 0 ? '0' : this.formData.min_x || ''"
            @change_input="(value) => onChange('min_x', value)"
          />
          <CustomInput
            label="Min Y"
            type="number"
            :allowNegative="true"
            :value="this.formData.min_y === 0 ? '0' : this.formData.min_y || ''"
            @change_input="(value) => onChange('min_y', value)"
          />
          <CustomInput
            label="Max Y"
            type="number"
            :allowNegative="true"
            :value="this.formData.max_y === 0 ? '0' : this.formData.max_y || ''"
            @change_input="(value) => onChange('max_y', value)"
          />
        </div>
      </section>

      <section class="ms-form-section">
        <h3 class="ms-form-section__title"><i class="fa-solid fa-paperclip" aria-hidden="true" />Файлы и комментарий</h3>
        <div class="ms-form-grid">
          <div class="ms-form-wide">
            <CustomUploader
              :value="this.formData?.image"
              :on-change="(value) => this.onChange('image', value)"
              title="Подложка"
            />
          </div>
          <div class="ms-form-wide">
            <CustomUploader
              :value="this.formData?.autocad"
              :on-change="(value) => this.onChange('autocad', value)"
              title="Исходники AutoCAD"
            />
          </div>
          <CustomInput
            label="Комментарий"
            type="textarea"
            class="ms-form-wide"
            :value="this.formData.comments || ''"
            @change_input="(value) => onChange('comments', value)"
          />
        </div>
      </section>

      <CustomModalFooter :btn-loading="this.loading" />
    </q-form>
  </div>
</template>
<script>

import CustomModalFooter from "@/components/modal/modals/modal-footer";
import CustomUploader from "@/components/form/CustomUploader";
import CustomInput from "@/components/form/CustomInput";
import { addFloorMap, editFloorMap } from "@/views/ResidentialSettings/services";
import { useCustomSnackbar } from "@/_helpers/hooks/useCustomSnackbar";
import { appActions } from "@/services/store/modules/app_module/app_actions";

export default {
  name: "add-floor-map",
  components: {CustomInput, CustomUploader, CustomModalFooter},
  props: ['data'],
  data() {
    return {
      loading: false,
      formData: {
        wall_height: '',
        door_height: '',
        window_height: '',
        autocad_scale: '',
        scale: '',
        min_y: '',
        min_x: '',
        max_y: '',
        slope_width: '',
        comments: '',
        code: '',
        image: null,
        autocad: null,
      }
    }
  },
  methods: {
    onChange(key, value) {
      this.formData[key] = value
    },
    async onSubmit() {
      let formData = new FormData()

      Object.keys(this.formData).forEach((key) => {
        if(this.formData[key] === null || this.formData[key] === undefined || this.formData[key] === 'undefined') return formData.append(key, '')
        if(key === 'image' || key === 'autocad') return
        formData.append(key, this.formData[key])
      })

      if (this.formData.image) {
        formData.append('image', this.formData.image[0])
      } else {
        formData.delete('image')
      }

      if (this.formData.autocad) {
        formData.append('autocad', this.formData.autocad[0])
      } else {
        formData.delete('autocad')
      }

      this.loading = true
      await this.handleEditFloorMap(formData)
      this.loading = false
    },
    async handleEditFloorMap(body) {
      let res = null
      if(this.data?.isEdit) {
        res = await editFloorMap(this.data?.floor_map_id, body, this.data?.params)
      } else {
        res = await addFloorMap(body, this.data?.params)
      }
      if (!res) return
      if(this.data?.onSubmit)
        await this.data?.onSubmit(res)
      this.showSucceedSnackbar()
      this.$store.commit(appActions.closeModal());
    }
  },
  mounted() {
    if(this.data?.body) {
          const {
          resident_id,
          level_num,
          wall_height,
          door_height,
          window_height,
          autocad_scale,
          scale,
          min_y,
          min_x,
          max_y,
          code,
          slope_width,
          comments
        } = this.data.body
      this.formData = {
        ...this.formData, wall_height,
          door_height,
          window_height,
          comments,
          resident_id,
          level_num,
          autocad_scale,
          scale,
          min_y,
          min_x,
          max_y,
          slope_width,
          code,
          }
    }
  },
  setup() {
    const {showSucceedSnackbar} = useCustomSnackbar()
    return {showSucceedSnackbar}
  }
}
</script>
